import i18n from 'i18n/config'

const languages = {
  es: {
    code: 'es',
    name: 'spanish',
    label: i18n.t('format:languages.spanish'),
    flag_code: 'es'
  },
  en: {
    code: 'en',
    name: 'english',
    label: i18n.t('format:languages.english'),
    flag_code: 'uk'
  },
  fr: {
    code: 'fr',
    name: 'french',
    label: i18n.t('format:languages.french'),
    flag_code: 'fr'
  },
  de: {
    code: 'de',
    name: 'german',
    label: i18n.t('format:languages.german'),
    flag_code: 'de'
  },
  it: {
    code: 'it',
    name: 'italian',
    label: i18n.t('format:languages.italian'),
    flag_code: 'it'
  },
  pt: {
    code: 'pt',
    name: 'portuguese',
    label: i18n.t('format:languages.portuguese'),
    flag_code: 'pt'
  },
  ca: {
    code: 'ca',
    name: 'catalan',
    label: i18n.t('format:languages.catalan'),
    flag_code: 'ca'
  },
  zh: {
    code: 'zh',
    name: 'chinese',
    label: i18n.t('format:languages.chinese'),
    flag_code: 'zh'
  }
}

export default languages
